import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-multiselect/dist/vue-multiselect.min.js';

import Vue from 'vue';
import VueMultiselect from 'vue-multiselect';

Vue.component('VMultiselect', VueMultiselect);

export default VueMultiselect;
